module.exports = __webpack_public_path__ + "static/media/TaskManagement_Staff_001.d5be6061.png";